import React, { forwardRef, useImperativeHandle, useState } from 'react'
import { Form } from 'react-bootstrap'
import Fade from 'react-awesome-reveal'
import '../../styles/Input/InputFile.css'

const InputFile = forwardRef((props, ref) => {

    useImperativeHandle(ref, () => ({ fileValidation: (file) => fileValidation(file) }))

    const [filename, setFilename] = useState()

    function fileValidation(files) {

        if (files && files.length > 0) {
            var filename = []
            for (var i = 0; i < files.length; i++) {
                filename.push(files[i].name)
            }
            setFilename(filename)
            if (props.format && props.format[0] !== "all") {
                for (let i2 = 0; i2 < files.length; i2++) {
                    if (props.format.find((item2) => item2 === /(?:\.([^.]+))?$/.exec(files[i2].name)[1]) === undefined) {
                        props.setFileError(true)
                        return true
                    }
                }
            }
            props.setFileError(false)
            return true
        } else {
            props.setFileError(true)
            return false
        }

    }

    return (

        <Form.Group className='mb-3'>
            <div className='inputFileText'>
                {props.text}
            </div>
            <Form.Control
                type='file'
                multiple={props.multiple}
                className={props.fileError == null ? 'inputFile' : !props.fileError ? 'inputFileSuccess' : 'inputFileError'}
                onChange={(e) => { props.setFile(e.target.files[0]); fileValidation(e.target.files) }}
            />
            {filename ?
                filename.map((itemName) => {
                    return (
                        <Fade key={itemName} top>
                            {props.format[0] === 'all' || props.format.find((itemFormat) => itemFormat === /(?:\.([^.]+))?$/.exec(itemName)[1]) ?
                                <div className={'inputFilePreviewSuccess'}>
                                    <li>{itemName} ({props.textExtSuccess})</li>
                                </div>
                                :
                                <div className={'inputFilePreviewError'}>
                                    <li>{itemName} ({props.textExtError})</li>
                                </div>
                            }
                        </Fade>
                    )
                })
                : null
            }
        </Form.Group >

    )

})

export default InputFile
